import { render, staticRenderFns } from "./PodMetrics.vue?vue&type=template&id=1720138e&"
import script from "./PodMetrics.vue?vue&type=script&lang=js&"
export * from "./PodMetrics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports